import { useContext, useEffect } from 'react';
import { AppContext } from '../../context/AppContext';
import { NavBarSession } from '../Navbar/NavBarSession';
import { ContentContext } from '../../context/ContentContext';

import { CarnetPage, PerfilPage, ResultadosPage } from '../pages/aspirantes/index';

export const DashboardPage = () => {
	const { item, removeItemContent } = useContext(ContentContext);

	useEffect(() => {
		removeItemContent();
	}, []);

	const setChildren = () => {
		switch (item) {
			case 'Perfil':
			case 'PDF':
				return <PerfilPage />;
			case 'Carnet':
				return <CarnetPage />;
			case 'Resultados':
				return <ResultadosPage />;
			default:
				return <PerfilPage />;
		}
	};

	return (
		<div>
			<NavBarSession />
			<div className="children">{setChildren()}</div>
		</div>
	);
};
